/**
 * partnersApi.ts (portail client) - wrapper public pour /api/partners
 *
 * Anonyme. Les partenaires sont saisis dans l admin (app-admin) et stockes en
 * Cosmos 'partners'. Seuls les partners actifs (active=true) sont exposes.
 */
import { apiFetch } from './apiClient';

export interface PublicPartner {
  id:           string;
  /** Identifiant slug (pour matcher le partenaire rattaché au client). */
  slug?:        string;
  name:         string;
  tagline:      string;
  contactName:  string;
  email:        string;
  technologies: string[];
  city:         string;
  country:      string;
  logoUrl?:     string | null;
  /** v2026.06 - Si true, badge "Recommande" + tri en tete. */
  preferred?:   boolean;
  /** v2026.06 - Description riche (HTML) affichee sur la page "Mon partenaire". */
  description?: string;
  /** v2026.06 - Page LinkedIn de la societe. */
  linkedinUrl?: string | null;
  /** v2026.06 - URL d'embed d'un post LinkedIn specifique (iframe). */
  linkedinEmbedUrl?: string | null;
}

export const partnersApi = {
  list: () => apiFetch<{ partners: PublicPartner[] }>('/partners'),

  /** Le client choisit son partenaire (DEFINITIF) — cas auto-signup sans partenaire. */
  choosePartner: (slug: string) =>
    apiFetch<{ partnerSlug: string; alreadySet: boolean }>('/clients/partner', {
      method:  'POST',
      body:    JSON.stringify({ slug }),
      headers: { 'Content-Type': 'application/json' },
    }),
};
